export default __webpack_public_path__ + "static/media/support-center.8919a857.svg";